import { render, staticRenderFns } from "./v-resales-list-item.pug?vue&type=template&id=4ac17831&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./v-resales-list-item.scss?vue&type=style&index=0&id=4ac17831&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac17831",
  null
  
)

export default component.exports